import React from "react";
import Navbar from "../components/Test_components/navbar";
import HeroSection from "../components/Test_components/hero-section";
import { Disc } from "lucide-react";
import GroupsSection from "../components/Test_components/groups-section";
import ScoopsSection from "../components/Test_components/scoops-section";
import EventsSection from "../components/Test_components/events-section";
import AdvertiseSection from "../components/Test_components/advertisement-section";
import RentalSection from "../components/Test_components/rentals-section";
import DiscoverSection from "../components/Test_components/discover-section";
import { useState } from "react";
import Footer from "../components/Test_components/footer";
import CTASection from "../components/Test_components/cta-section";
function Test() {
  const [search, setSearch] = useState("");
  return (
    <>
      <Navbar />
      <HeroSection searchValue={search} onSearchChange={setSearch} />
      <GroupsSection />
      <ScoopsSection />
      <EventsSection />
      <RentalSection />
      <AdvertiseSection />
      <DiscoverSection />
      <CTASection />
      <Footer />
    </>
  );
}

export default Test;
